export const MESSAGES = {
    MANDATORY : "This field is mandatory",
    MAX_LENGTH : "Maximum length must be #{value}",
    MIN_LENGTH : "Minimum length must be #{value}",
    REG_EX : "Invalid format",
    MIN_SIZE : "Select atleast #{value}",
    MAX_SIZE : "Can't select more than #{value}",
    SPACE:"Can't start with space",
    ALLOWED_TYPES: "Please select allowed file types only (#{value})"
}  